import classNames from 'classnames'
import React from 'react'

import Icon, {Icons} from '../../icons/Icon'
import {InputTypes} from '../Input'

interface TrailingComponentProps {
  type?: InputTypes;
  disabled?: boolean;
  showValue?: boolean;
  toggleShowPassword?: () => void;
  trailingIcon?: Icons;
}

const TrailingComponent = ({
  type,
  disabled,
  showValue,
  toggleShowPassword,
  trailingIcon
}: TrailingComponentProps) => {
  const trailingIconWrapperClassNames = classNames(
    'absolute inset-y-0 flex items-center right-3',
    {
      'fill-kwota-neutral-600': !disabled,
      'fill-kwota-neutral-400': disabled
    }
  )

  if (type === 'search') {
    return (
      <div className={trailingIconWrapperClassNames}>
        <Icon icon="magnifier" className="pointer-events-none fill-inherit" />
      </div>
    )
  }

  if (type === 'password') {
    return (
      <div className={trailingIconWrapperClassNames}>
        <Icon
          onClick={toggleShowPassword}
          icon={showValue ? 'eye-slash' : 'eye'}
          className="fill-inherit"
        />
      </div>
    )
  }

  if (!trailingIcon) return null

  return (
    <div className={trailingIconWrapperClassNames}>
      <Icon icon={trailingIcon} className="cursor-pointer fill-inherit" />
    </div>
  )
}

export default TrailingComponent
